//TODO: Change to centered on user location when we expand to multiple states?

import { BBox } from 'geojson';

// Currently centered on Charlotte
export const DEFAULT_POSITION = {
  lat: 35.226867,
  lng: -80.843382,
  zoom: 10,
  bbox: [-81.058199, 35.001712, -80.555397, 35.40261] as BBox,
};

//TODO: Move mapping todatabase
export const MLS_TO_BBOX_MAP: Record<string, BBox> = {
  CanopyMLS: [-81.058199, 35.001712, -80.555397, 35.40261], // Charlotte
  TriadMLS: [-79.993419, 35.909682, -79.649989, 36.248687], // Greensboro
  TriangleMLS: [-78.817592, 35.563197, -78.431937, 36.010427], // Raleigh
  GreenvilleSC: [-82.52594, 34.717486, -82.228859, 34.968378], // Greenville
  FMLS: [-84.632649, 33.586921, -84.243656, 33.91881], // Atlanta
  GeorgiaMLS: [-84.632649, 33.586921, -84.243656, 33.91881], // Atlanta
};

export const ZOOM_LEVEL_MARKER_CHANGE = 11;
